import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const PrivyOTPInputLazy = lazyLoader(
  () => import('./PrivyOTPInput' /* webpackChunkName: "loan-privy-otp" */),
);

const PrivyOTPInput = () => {
  return (
    <Suspense fallback={null}>
      <PrivyOTPInputLazy />
    </Suspense>
  );
};

export default PrivyOTPInput;
